import React, { FC } from 'react';
import { TutoringType } from 'logic/api-models/tutoring-type';
import { GroupWrap } from 'components/group-wrap/group-wrap';
import { map } from 'lodash';
import { BadgePrimary } from 'components/badge/BadgePrimary';
import { translate, translationKeys } from 'logic/translations/translations.service';
import { Field } from 'redux-form';

type OnChange = (locations: TutoringType[]) => void;
type FieldComponentProps = { input: { onChange: OnChange } };
type Props = {
  fieldName: string;
  tutoringTypesAvailable: TutoringType[];
  selectedTypes: TutoringType[];
};

export const FormInputTutoringTypeBadges: FC<Props> = ({
  tutoringTypesAvailable,
  fieldName,
  selectedTypes,
}) => {
  const toggleBadgeActive = (locationAvailable: TutoringType) =>
    selectedTypes.includes(locationAvailable)
      ? selectedTypes.filter((location) => location !== locationAvailable)
      : [...selectedTypes, locationAvailable];

  return (
    <Field
      name={fieldName}
      component={({ input: { onChange } }: FieldComponentProps) => (
        <GroupWrap gap={0.5}>
          {map(tutoringTypesAvailable).map((locationAvailable: TutoringType) => (
            <BadgePrimary
              onClick={() => onChange(toggleBadgeActive(locationAvailable))}
              key={locationAvailable}
              color={selectedTypes.includes(locationAvailable) ? undefined : 'none'}
            >
              {translate(translationKeys.common.teachingLocation[locationAvailable])}
            </BadgePrimary>
          ))}
        </GroupWrap>
      )}
    />
  );
};
